"use client";
import React, { FC, useRef } from "react";

import { MdArrowBack as ArrowBack } from "react-icons/md";

import Link from "components/animated-link";

import { Tooltip } from "./tooltip";

interface BackNavigationLinkProps {
  /**
   * The ARIA label for the link.
   */
  ariaLabel?: string;
  /**
   * Determines whether the tooltip should be disabled.
   */
  disableTooltip?: boolean;
  /**
   * The URL to navigate to when the link is clicked.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  href: any;
  /**
   * The label text for the link.
   */
  label?: string;
}

export const BackNavigationLink: FC<
  BackNavigationLinkProps & {
    translations: {
      backTo: string;
    };
  }
> = ({ ariaLabel, disableTooltip = false, href, label, translations }) => {
  const t = translations;
  const linkRef = useRef(null);

  return (
    <Link
      className="not-prose group mb-6 inline-flex items-center no-underline underline-offset-[0.2em] hover:underline focus:underline focus:outline-0 focus-visible:outline focus-visible:outline-8 focus-visible:outline-offset-4 focus-visible:outline-darkblue dark:focus-visible:outline-white"
      href={href}
      ref={linkRef}
    >
      {disableTooltip ? null : (
        <Tooltip anchorEl={linkRef.current} title={`${t.backTo}${ariaLabel}`} />
      )}
      <ArrowBack
        aria-hidden={ariaLabel ? undefined : true}
        aria-label={ariaLabel ? t.backTo : undefined}
        className="mr-2 inline-flex text-2xl opacity-70 group-focus-within:opacity-100 group-hover:opacity-100"
        role={ariaLabel ? "img" : undefined}
      />
      <span>{ariaLabel || label}</span>
    </Link>
  );
};

export default BackNavigationLink;
